import {
  Heading,
  Tab,
  TabContent,
  Tabs,
  TabsList,
} from '@utilitywarehouse/hearth-react';
import {
  CloseSmallIcon,
  TickSmallIcon,
} from '@utilitywarehouse/hearth-react-icons';

import { useSyncState } from '@hooks/useSyncState';

import { Covered } from './Covered';
import { NotCovered } from './NotCovered';
import './styles.scss';

const Protection = () => {
  const [isCovered, setIsCovered] = useSyncState('ip-covered-tab', 'covered');

  const handleChange = (newValue: string) => {
    setIsCovered(newValue);
  };

  return (
    <section className="incomeProtector__coverage__wrapper">
      <header>
        <Heading className="heading" as="h3" size="lg">
          What's covered?
        </Heading>
      </header>
      <Tabs value={isCovered} onValueChange={handleChange}>
        <TabsList>
          <Tab value="covered">
            <TickSmallIcon /> Covered
          </Tab>
          <Tab value="notCovered">
            <CloseSmallIcon /> Not covered
          </Tab>
        </TabsList>
        <TabContent value="covered">
          <Covered />
        </TabContent>
        <TabContent value="notCovered">
          <NotCovered />
        </TabContent>
      </Tabs>
    </section>
  );
};

export { Protection };
